import styles from "./LandingHero.module.css";
import {
  AlternatingImages,
  BrowserMock,
  Button,
  Typography,
} from "@grantyd/ui";
import { landingHeroContent as heroContent } from "@/data/landingpage";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Link } from "react-router";
import brightFutures from "@/assets/images/bright-futures.png";
import discoveryDash2 from "@/assets/images/discovery-dash-2.png";
import individualGiving from "@/assets/images/individual-giving.png";

const LandingHero = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.content}>
          <Typography
            as="h1"
            variant={isDesktop ? "display-lg" : "display-sm"}
            color="primary"
          >
            {heroContent.title.split(heroContent.titleHighlight)[0]}{" "}
            <Typography
              as="span"
              variant={isDesktop ? "display-lg" : "display-sm"}
              color="tertiary"
            >
              {heroContent.titleHighlight}
            </Typography>
          </Typography>
          <Typography variant="body-lg" color="primary">
            {heroContent.subtitle}
          </Typography>

          <div className={styles.actions}>
            <Link to={heroContent.ctaButton.ctaUrl}>
              <Button>{heroContent.ctaButton.label}</Button>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <AlternatingImages>
          <BrowserMock>
            <img src={brightFutures} />
          </BrowserMock>
          <BrowserMock>
            <img src={discoveryDash2} />
          </BrowserMock>
          <BrowserMock>
            <img src={individualGiving} />
          </BrowserMock>
        </AlternatingImages>
      </div>
    </div>
  );
};

export default LandingHero;
